import styles from './variable.module.scss';

export const GNB_HEIGHT = 100;
export const HEADER_HEIGHT = Number(styles.HEADER_HEIGHT);
export const MAIN_TAB_HEIGHT = Number(styles.MAIN_TAB_HEIGHT);
export const SUB_TAB_HEIGHT = Number(styles.SUB_TAB_HEIGHT);
export const SUB_TAB_HEIGHT_PX = `${SUB_TAB_HEIGHT}px`;
export const DEFAULT_SMALL_SIZE = Number(styles.DEFAULT_SMALL_SIZE);
export const DEFAULT_MEDIUM_SIZE = Number(styles.DEFAULT_MEDIUM_SIZE);
export const DEFAULT_MEDIUM_SIZE_PX = `${DEFAULT_MEDIUM_SIZE}px`;
export const DEFAULT_LARGE_SIZE = Number(styles.DEFAULT_LARGE_SIZE);
export const DEFAULT_MAX_WIDTH = Number(styles.DEFAULT_MAX_WIDTH);
export const DEFAULT_ANIMATION_DURATION = Number(
  styles.DEFAULT_ANIMATION_DURATION
);
export const DEFAULT_TAB_HEIGHT = 49;
export const DEFAULT_TAB_HEIGHT_PX = `${DEFAULT_TAB_HEIGHT}px`;

export const ZIndex = {
  Flicker: 20,
  WaterMark: 40,
  ContentTab: 90,
  NavigationBar: 100,
  ContentFloatingBar: 150,
  Message: 180,
  Modal: 200,
  Toast: 300,
  Loading: 1000,
};
